const buildForLoginHistoryTable = (currentPage) => {
  const url = new URL(`${process.env.BACKEND_URL}/generated/records/login_history`);
  url.searchParams.set("join", "users");
  url.searchParams.set("page", currentPage);
  return url;
};

const buildForUserForm = (id = 1) =>
  `${process.env.BACKEND_URL}/users/${id}`;

const buildForUsersTable = (currentPage = 1) => {
  const url = new URL(`${process.env.BACKEND_URL}/generated/records/users`);
  url.searchParams.set("join", "roles");
  url.searchParams.set("exclude", "password");
  url.searchParams.set("page", currentPage);
  return url;
};

const urlBuilder = {
  buildForLoginHistoryTable,
  buildForUserForm,
  buildForUsersTable,
};

export default urlBuilder;



// WEBPACK FOOTER //
// ./src/user/api-services/_urlBuilder.js